module.exports = __webpack_public_path__ + "static/favicon.c92b85a5.ico";


//////////////////
// WEBPACK FOOTER
// ./static/logos/favicon.ico
// module id = 1893
// module chunks = 114276838955818